/* eslint-disable arrow-body-style */
/* eslint-disable prefer-template */
/* eslint-disable react/prop-types */
import React from 'react';

const BoxBorderSmall = (props) => {

    return (
        <div className="boxBorder">
            <svg version="1.1" className="boxBorder__image" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 463.7 195.1" enableBackground="new 0 0 463.7 195.1" xmlSpace="preserve" preserveAspectRatio="none">
                <path className="boxBorder__path" id={props.id} fillRule="evenodd" clipRule="evenodd" fill="none" stroke="#FFFFFF" strokeWidth="5" strokeMiterlimit="10" d="M232.2,192.5h-220c-5.3,0-9.6-4.3-9.6-9.6L2.7,12.1c0-5.3,4.3-9.6,9.6-9.5l439.6-0.2c5.3,0.2,9.6,4.5,9.6,9.8v170.7c0,5.3-4.3,9.6-9.6,9.6H232.2z"/>
            </svg>
        </div>
    );
}

export default BoxBorderSmall;



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/BoxBorderSmall.jsx